import React, { Component } from 'react'
import Box from '@mui/material/Box';
import { Paper, Typography } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import { Link } from 'react-router-dom';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import StoreIcon from '@mui/icons-material/Store';
import GroupsIcon from '@mui/icons-material/Groups';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import RealEstateAgentIcon from '@mui/icons-material/RealEstateAgent';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';

import AddchartIcon from '@mui/icons-material/Addchart';
import WorkIcon from '@mui/icons-material/Work';




export class Sidebar extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       first:''
    }
  }
  render() {

    let currentLocation = window.location.pathname

    return (
      <div>
<Paper elevation={1} sx={{display:{xs:'none',sm:'block'},backgroundColor:'#444b52',width:80,minHeight:'93vh',borderRadius:0,position:'static'}}>

<Link to='/dashboard'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/dashboard'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<DashboardOutlinedIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Dashboard</Typography>
</Box> 
</Link>


 <Accordion elevation={0} sx={{backgroundColor:'#262f36'}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{color:'#fff'}} />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span" sx={{fontSize:10,fontWeight:'bold',color:'#fff'}}>Ekbs</Typography>
        </AccordionSummary>
 



<Link to='/Vendors'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/Vendors'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<Diversity2Icon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Vendors</Typography>
</Box> 
</Link>


<Link to='/Franchise'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/Franchise'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<Diversity3Icon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Franchise</Typography>
</Box> 
</Link>


<Link to='/Customer'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/Customer'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<GroupsIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Customers</Typography>
</Box> 
</Link>


<Link to='/Orders'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/Orders'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<StoreIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Orders</Typography>
</Box> 
</Link>


<Link to='/Settings'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/Settings'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<SettingsOutlinedIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Settings</Typography>
</Box> 
</Link>


 </Accordion>


 <Accordion elevation={0} sx={{backgroundColor:'#262f36',mt:2}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon  sx={{color:'#fff'}} />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span" sx={{fontSize:10,fontWeight:'bold',color:'#fff'}}>Realestate</Typography>
        </AccordionSummary>

<Link to='/propertyList'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/propertyList'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<PlaylistAddCheckIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>PropertList</Typography>
</Box> 
</Link>

<Link to='/addProperty'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/addProperty'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<RealEstateAgentIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Add Property</Typography>
</Box> 
</Link>



<Link to='/addBuilder'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/addBuilder'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<GroupAddIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Add Builder</Typography>
</Box> 
</Link>


<Link to='/builderList'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/builderList'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<ChecklistRtlIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Builder List</Typography>
</Box> 
</Link>



<Link to='/property_leads'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/property_leads'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<LeaderboardIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Property Leads</Typography>
</Box> 
</Link>


 </Accordion>





 <Accordion elevation={0} sx={{backgroundColor:'#262f36',mt:2}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon  sx={{color:'#fff'}} />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span" sx={{fontSize:10,fontWeight:'bold',color:'#fff'}}>Job</Typography>
        </AccordionSummary>
 



<Link to='/addCompany'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/addCompany'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<AddchartIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Add Company</Typography>
</Box> 
</Link>




<Link to='/companyList'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/companyList'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<Diversity2Icon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Compnay list</Typography>
</Box> 
</Link>



<Link to='/jobList'>
<Box sx={{height:75,width:'100%',backgroundColor:currentLocation=='/jobList'?'#262f36':'#444b52',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
<ChecklistRtlIcon sx={{height:22,width:22,color:'#fff'}}/>
<Typography sx={{fontSize:11,color:'#fff',mt:0.5}}>Job List</Typography>
</Box> 
</Link>






 </Accordion>












</Paper>
      </div>
    )
  }
}

export default Sidebar